"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FieldError = ({ label }) => {
    return (react_1.default.createElement("div", { style: { backgroundColor: '#990000', color: '#fff', padding: '20px' } }, label));
};
exports.default = FieldError;
//# sourceMappingURL=FieldError.js.map